import { store } from '@/redux/lib/configureStore.js';
import { action } from '../../../lib/api';

export const sendAiChatMessage = (message, opts = {}) => {
  const currentContext = store
    .getState()
    .ui.aiChat?.messages?.filter((msg) => msg.role === 'system')
    ?.pop()?.content;

  action('uiSetAiChat', { open: true });
  action('uiSendAiChatMessage', {
    message,
    context: currentContext !== opts.context ? opts.context : undefined
  });
};

export const toggleAiChat = ({ open }) => {
  if (open === undefined) {
    action('uiToggleAiChat');
  } else {
    action('uiSetAiChat', { open });
  }
};

export const clearAiChat = async () => {
  action('uiClearAiChat');
};
